import useCountryAxiosInstance from "@hooks/useCountryAxiosInstance";
import { CrossServicesConfigurationSchema} from "../types";

export const useCrossServicesConfigurations = () => {
  const countryApiRequest = useCountryAxiosInstance();
  const getCrossServicesConfigurations = (service_id: number, version: number | unknown) => {
    return countryApiRequest.get(`/cross_services_configurations/service/${service_id}/version/${version}`);
  }

  const upsertCrossServicesConfiguration = (
    crossServicesConfiguration: CrossServicesConfigurationSchema
  ) => {
    let payload = {
      ...crossServicesConfiguration,
      r_perm: ['public'],
      w_perm: ['public'],
    }
    if (crossServicesConfiguration.id) {
      return countryApiRequest.put(`/cross_services_configurations/${crossServicesConfiguration.id}`, crossServicesConfiguration);
    } else {
      return countryApiRequest.post(`/cross_services_configurations`, crossServicesConfiguration);
    }
  }

  return {
    getCrossServicesConfigurations,
    upsertCrossServicesConfiguration
  }

}